import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppFacade } from "@app/core/app-services";
import { filter } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { Languages } from "@app/core/models";

@Component({
  selector: 'ingo-mastercard-landing-page',
  templateUrl: './mastercard-landing-page.component.html',
  styleUrls: ['./mastercard-landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MastercardLandingPageComponent implements OnInit {

  redirectPage: string = "/cards/add-mastercard-confirm";
  redirectSuffix: string = "";
  redirectUrl: string[];

  @Input() processing: boolean = false;

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private appFacade: AppFacade,
      private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.setLanguage();
    this.extractRedirectSuffix();
    this.prepareRedirectUrl();
    this.authenticateOrGoToConfirmationPage();
  }

  private setLanguage() {
      this.translate.use(Languages.SWEDISH.code)
  }

  private extractRedirectSuffix() {
    if (this.route.firstChild) {
      this.route.firstChild.paramMap.subscribe(params => {
        this.redirectSuffix = params.get('hash') ? params.get('hash') : "";
      });
    }
  }

  private prepareRedirectUrl() {
    this.redirectUrl = [this.redirectPage, this.redirectSuffix];
  }

  private authenticateOrGoToConfirmationPage() {
    this.appFacade.isAuthenticated()
      .pipe(filter(status => status === true))
      .subscribe(() => this.goToConfirmUrl());
  }

  private goToConfirmUrl(): void {
    this.router.navigate(this.redirectUrl);
  }
}
